/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const GetStorageClasses = {
  id: 'storage-classes.get',
  tag: 'Product',
  summary: 'Get storage classes',
  description: 'Retrieves available storgae classes.',
  method: 'get',
  route: () => `/product/storage-class`,
  flags: { isAuthorized: true },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.TrimmedString,
              isDefault: z.boolean(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
